import { render, staticRenderFns } from "./Renungan.vue?vue&type=template&id=34b98c36&scoped=true&"
import script from "./Renungan.vue?vue&type=script&lang=js&"
export * from "./Renungan.vue?vue&type=script&lang=js&"
import style0 from "./Renungan.vue?vue&type=style&index=0&id=34b98c36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b98c36",
  null
  
)

export default component.exports